export const atsPreschoolGrades = ['0K', 'IN', 'PK'];